import React from 'react'

// eslint-disable-next-line react/display-name
export default () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.0874 0.489897L15.5109 1.91438C16.1631 2.56873 16.1631 3.62747 15.5109 4.28182L14.5615 5.23348C14.4306 5.36439 14.2184 5.36439 14.0874 5.23348L10.7685 1.91438C10.6376 1.78343 10.6376 1.57117 10.7685 1.44022L11.7193 0.489897C12.3736 -0.163299 13.4331 -0.163299 14.0874 0.489897ZM10.0567 2.62587C9.99391 2.56253 9.90849 2.52681 9.81932 2.52661C9.73025 2.52663 9.64485 2.5621 9.58197 2.6252L2.2588 9.95216C2.12793 10.0831 2.12793 10.2954 2.2588 10.4263L5.57642 13.7448C5.70733 13.8757 5.91955 13.8757 6.05046 13.7448L13.3703 6.42315C13.5007 6.29228 13.5007 6.08053 13.3703 5.94966L10.0567 2.62587ZM1.58217 11.2187C1.49631 11.1331 1.37095 11.1005 1.2543 11.1335C1.13746 11.1663 1.04745 11.2596 1.01895 11.3776L0.00918624 15.5874C-0.0179116 15.7008 0.0158588 15.8202 0.0983622 15.9026C0.181353 15.9841 0.300227 16.0175 0.413495 15.9911L4.61884 14.9851C4.73693 14.9568 4.8305 14.8669 4.86347 14.75C4.89644 14.6332 4.86365 14.5076 4.77775 14.4218L1.58217 11.2187Z"
      fill="#363A53"
    />
  </svg>
)
